import { jwtDecode } from "jwt-decode";

export type AuthPayload = {
  name: string;
  username: string;
  role: string;
  iat: number;
  exp: number;
  permissions: string[];
  id: string;
};

export function checkAuthStatus(): boolean {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const decoded = jwtDecode<any>(token);
    const currentTime = Date.now() / 1000;

    return decoded.exp && decoded.exp > currentTime;
  } catch (e) {
    return false;
  }
}

export function getAuthPayload(): AuthPayload | undefined {
  try {
    const token = localStorage.getItem("token");

    if (token) {
      return jwtDecode<AuthPayload>(token);
    }
  } catch (e) {
    console.error(e);
  }
}
